import { queryOptions } from "@tanstack/react-query";
import { showRnmRequest } from "../../../../../__generated__/orval/endpoints/rnm-requests/rnm-requests";

export const rnmRequestLoaderQueryOptions = (rnmRequestId: string) =>
  queryOptions({
    queryFn: () => showRnmRequest(Number(rnmRequestId)),
    queryKey: ["rnmRequests", "detail", Number(rnmRequestId)],
  });
